import { useCallback, useState } from 'react';

/**
 * Boolean open/closed state persisted in localStorage.
 *
 * Used for collapsible page sections (insights panels, nav groups) so a volunteer's
 * preference survives a refresh or returning to the page later.
 */
export const usePersistedOpen = (
  storageKey: string,
  defaultOpen = true,
): [boolean, (open: boolean) => void] => {
  const [open, setOpenState] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw === '0') return false;
      if (raw === '1') return true;
    } catch {
      // Ignore quota / private-mode failures.
    }
    return defaultOpen;
  });

  const setOpen = useCallback(
    (next: boolean) => {
      setOpenState(next);
      try {
        localStorage.setItem(storageKey, next ? '1' : '0');
      } catch {
        // Ignore quota / private-mode failures.
      }
    },
    [storageKey],
  );

  return [open, setOpen];
};
